export default __webpack_public_path__ + "static/media/earlySubscriberAndroid_4.c2772b88.svg";